module.exports = __webpack_public_path__ + "static/img/压铸自动化产线.8796b037.png";